export const HOME = { emergentLink: "home-emergent-link" };

export const LOGIN = {
  page: "login-page",
  googleBtn: "google-signin-btn",
  loadSampleBtn: "landing-load-sample-btn",
  tabSignin: "login-tab-signin",
  tabSignup: "login-tab-signup",
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  nameInput: "login-name-input",
  submitBtn: "login-submit-btn",
  errorMsg: "login-error-msg",
};

export const NAV = {
  bar: "top-nav",
  logo: "nav-logo",
  linkDashboard: "nav-link-dashboard",
  linkUpload: "nav-link-upload",
  linkSettings: "nav-link-settings",
  userMenu: "nav-user-menu",
  logoutBtn: "nav-logout-btn",
  accountPicker: "nav-account-picker",
  accountOption: (id) => `nav-account-${id}`,
};

export const DASH = {
  page: "dashboard-page",
  kpiCard: (k) => `kpi-card-${k}`,
  loadfactorChart: "chart-loadfactor-cpk",
  monthlyChart: "chart-monthly-kwh",
  co2Chart: "chart-co2-trend",
  breakdownChart: "chart-cost-breakdown",
  billsTable: "bills-table",
  billRow: (id) => `bill-row-${id}`,
  deleteBillBtn: (id) => `bill-delete-${id}`,
  emptyState: "dash-empty-state",
  loadSampleBtn: "dash-load-sample-btn",
  aiInsights: "ai-insights-panel",
  refreshInsightsBtn: "refresh-insights-btn",
  yoyBlock: "yoy-block",
  tariffCallout: "tariff-callout",
  budgetAlert: "budget-alert",
  exportPdfBtn: "export-pdf-btn",
  compareWidget: "compare-widget",
  compareMetric: (k) => `compare-metric-${k}`,
};

export const UPLOAD = {
  page: "upload-page",
  dropzone: "upload-dropzone",
  fileInput: "upload-file-input",
  submitBtn: "upload-submit-btn",
  manualForm: "manual-bill-form",
  manualMonth: "manual-month",
  manualStart: "manual-start",
  manualEnd: "manual-end",
  manualDays: "manual-days",
  manualKwh: "manual-kwh",
  manualCost: "manual-cost",
  manualSubmit: "manual-submit",
};

export const SETTINGS = {
  page: "settings-page",
  addAccountBtn: "settings-add-account",
  accountRow: (id) => `settings-account-${id}`,
  saveBtn: (id) => `settings-save-${id}`,
  deleteBtn: (id) => `settings-delete-${id}`,
  shareToggle: (id) => `settings-share-toggle-${id}`,
  budgetInput: (id) => `settings-budget-${id}`,
  nameInput: (id) => `settings-name-${id}`,
  copyShareBtn: (id) => `settings-copy-share-${id}`,
};

export const PUBLIC = {
  page: "public-snapshot-page",
};

export const ADMIN = {
  page: "admin-page",
  navLink: "nav-link-admin",
  modeToggle: "admin-mode-toggle",
  modeAvg: "admin-mode-avg",
  modeTotal: "admin-mode-total",
  kpiCard: (k) => `admin-kpi-${k}`,
  usersCount: "admin-users-count",
  billsCount: "admin-bills-count",
  aiInsights: "admin-ai-insights",
  refreshInsightsBtn: "admin-refresh-insights",
  usersSection: "admin-users-section",
  usersTable: "admin-users-table",
  userRow: (uid) => `admin-user-row-${uid}`,
  stateBreakdown: "admin-state-breakdown",
  stateRow: (s) => `admin-state-${s}`,
  breakdownSection: "admin-breakdown-section",
  stateTable: "admin-state-table",
  districtTable: "admin-district-table",
  stateKpiRow: (s) => `admin-state-kpi-${s}`,
  districtKpiRow: (d) => `admin-district-kpi-${d}`,
};
